import { Component, Input, OnInit } from '@angular/core';
import {
    FieldSchema,
    LabelFieldOptionLinks,
    LabelFieldOption
} from '@lsq-frontend/remote-services/ar-app';
import { Color, Icons } from '@lsq-frontend/common-ui';
import { sortBy } from 'lodash';
import { ILinkLabel } from './linked-label/linked-label.component';

@Component({
    selector: 'dr-label-field',
    styleUrls: ['./dr-label-field.component.scss'],
    templateUrl: './dr-label-field.component.html'
})
export class LabelField implements OnInit {
    @Input() fieldSchema: FieldSchema;
    public TextStyleEnum = FieldSchema.TextStyleEnum;
    public fieldOption: LabelFieldOption;

    public readonly icons = Icons;
    public color = Color;

    constructor() {}

    public ngOnInit(): void {
        this.fieldOption = this.fieldSchema.fieldOption;
    }

    public buildLabelInjected(): ILinkLabel[] {
        const linkedLabel = [];
        const option: LabelFieldOption = this.fieldSchema.fieldOption;
        const label: string = this.fieldSchema.label;
        let counter = 0;
        let links: LabelFieldOptionLinks[] = option?.links;
        if (links) {
            links = sortBy(option.links, ['startIndex']);
            links.forEach((link: LabelFieldOptionLinks) => {
                const linkText: string = label.slice(link.startIndex, link.endIndex);
                const normalText: string = label.slice(counter, link.startIndex);
                if (normalText !== '') {
                    const normalObject = {
                        text: normalText,
                        action: undefined,
                        option: undefined
                    };
                    linkedLabel.push(normalObject);
                }
                if (linkText !== '') {
                    const linkedObject = {
                        text: linkText,
                        action: LabelFieldOptionLinks.ActionEnum[link.action],
                        option: link.link
                    };
                    linkedLabel.push(linkedObject);
                }
                counter = link.endIndex;
            });
        }
        const restLabel: string = label.slice(counter, label.length);
        if (restLabel !== '') {
            const normalObject = {
                text: restLabel,
                action: undefined,
                option: undefined
            };
            linkedLabel.push(normalObject);
        }
        return linkedLabel;
    }

    public renderIcon(): Icons {
        switch (this.fieldOption?.startIcon) {
            case LabelFieldOption.StartIconEnum.Account:
                return this.icons.User;
            case LabelFieldOption.StartIconEnum.Password:
                return this.icons.Key;
            case LabelFieldOption.StartIconEnum.SMS:
                return this.icons.Mobile;
        }
        return;
    }
}
